import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { GetMemberCountResponse } from "./membersCount.api";
import { GetMemberCountThunk } from "./membersCount.thunk";

export interface MembersCountStore {
  membersCount: GetMemberCountResponse;
}

export const InitialMembersCountState: MembersCountStore = {
  membersCount: { count: 0 },
};

const MembersCountSlice = createSlice({
  name: "MembersCountSlice",
  initialState: InitialMembersCountState,
  reducers: {
    setMembersCount(state, action: PayloadAction<GetMemberCountResponse>) {
      state.membersCount = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(GetMemberCountThunk.fulfilled, (state, action) => {
        if (action.payload) {
          state.membersCount = action.payload;
        }
      })
      .addCase(GetMemberCountThunk.rejected, (state, action) => {
        //
      });
  },
});

export const MembersCountActions = MembersCountSlice.actions;
export const MembersCountReducer = MembersCountSlice.reducer;
